import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import ConfigsTable from './ConfigsTable';
import ConfigCard from './ConfigCard';
import ConfigTest from './ConfigTest';
import { useGlobal } from '../contexts/GlobalContext';

function ConfigExplorerColumn({ refreshKey, onEditConfig, onDeleteConfig, onDuplicateConfig }) {
  const { mergeCurrentContext } = useGlobal();
  const [selectedConfig, setSelectedConfig] = useState(null);

  useEffect(() => {
    mergeCurrentContext({
      selectedConfig: selectedConfig ? { config_id: selectedConfig.config_id } : undefined,
    });
    return () => mergeCurrentContext({ selectedConfig: undefined });
  }, [selectedConfig, mergeCurrentContext]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          overflow: 'hidden',
          flex: 1,
          minHeight: 0,
        }}
      >
        <Box sx={{ p: 1.5, borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="subtitle1" fontWeight="medium">
            Feed Configs
          </Typography>
        </Box>
        <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', p: 2 }}>
          <ConfigsTable
            selectedConfig={selectedConfig}
            onSelectConfig={setSelectedConfig}
            refreshKey={refreshKey}
          />
        </Box>
      </Box>

      <ConfigCard
        config={selectedConfig}
        onEdit={onEditConfig}
        onDelete={async (config) => {
          await onDeleteConfig?.(config);
          setSelectedConfig(null);
        }}
        onDuplicate={onDuplicateConfig}
      />

      {selectedConfig && (
        <ConfigTest
          title={`Test Feed Config #${selectedConfig.config_id}`}
          configId={selectedConfig.config_id}
          config={selectedConfig}
        />
      )}
    </Box>
  );
}

export default ConfigExplorerColumn;
